module.exports = __webpack_public_path__ + "img/finance2.fb99ec29.png";